import React from 'react';
import { getCmsOptimizedUrl, NavLink } from '@rumblefish/ui';
import { Section, NavigationButton } from '@rumblefish/ui/Rumblefish23Theme';
import type { CaseStudy } from '@rumblefish/strapi/strapiTypes';
import {
  StyledGrid,
  StyledCard,
  StyledCardImageWrapper,
  StyledCardImage,
  StyledCardBody,
  StyledCompanyName,
  StyledCardTitle,
  StyledCardDescription,
  StyledReadMore,
  StyledButtonWrapper,
  StyledDescription,
  StyledSectionTitle,
  StyledOurWorkWrapper,
} from './styles';

interface OurWorkProps {
  caseStudies: CaseStudy[];
}

export const OurWork: React.FC<OurWorkProps> = ({ caseStudies }) => {
  if (!caseStudies || caseStudies.length === 0) return null;

  return (
    <StyledOurWorkWrapper>
    <Section width="normal">
      <StyledSectionTitle variant="display_sm">Our work</StyledSectionTitle>
      <StyledDescription variant="strong_400">
        Zero-knowledge proofs in production - here&apos;s a glimpse of what we&apos;ve built.
      </StyledDescription>

      <StyledGrid>
        {caseStudies.map((caseStudy) => (
          <NavLink
            key={caseStudy.documentId}
            to={`/case-studies/${caseStudy.slug}/`}>
            <StyledCard>
              <StyledCardImageWrapper>
                <StyledCardImage
                  src={getCmsOptimizedUrl({
                    url: caseStudy.image?.url ?? '',
                    width: 600,
                    quality: 70,
                  })}
                  alt={caseStudy.image?.caption ?? caseStudy.title ?? ''}
                />
              </StyledCardImageWrapper>
              <StyledCardBody>
                {caseStudy.companyName && (
                  <StyledCompanyName variant="caption">
                    {caseStudy.companyName}
                  </StyledCompanyName>
                )}
                <StyledCardTitle variant="h3">{caseStudy.title}</StyledCardTitle>
                <StyledCardDescription variant="body2">
                  {caseStudy.cardDescription}
                </StyledCardDescription>
                <StyledReadMore variant="body2">Read more →</StyledReadMore>
              </StyledCardBody>
            </StyledCard>
          </NavLink>
        ))}
      </StyledGrid>

      <StyledButtonWrapper>
        <NavigationButton
          target={
            caseStudies.length < 3
              ? '/case-studies/'
              : '/case-studies/?filter=zero-knowledge-proof-development'
          }
          buttonText={caseStudies.length < 3 ? 'See other projects' : 'Explore more'}
          color="raspberry"
          ariaLabel="Explore more zero-knowledge proof case studies"
        />
      </StyledButtonWrapper>
    </Section>
    </StyledOurWorkWrapper>
  );
};
